export function hasPermissionMatch(userPermissions: string[], required: string): boolean {
  if (userPermissions.includes('*')) return true;
  if (userPermissions.includes(required)) return true;

  const parts = required.split('.');
  const [module, resource, action] = parts;
  if (module && resource) {
    if (userPermissions.includes(`${module}.${resource}.*`)) return true;
    if (userPermissions.includes(`${module}.*.*`)) return true;
    // Support legacy .read keys against .view permissions
    if (action === 'read' && userPermissions.includes(`${module}.${resource}.view`)) return true;
    if (action === 'view' && userPermissions.includes(`${module}.${resource}.read`)) return true;
    const writeActions = new Set(['create', 'update', 'delete']);
    if (action && writeActions.has(action) && userPermissions.includes(`${module}.${resource}.manage`)) return true;
    if (parts.length === 2 && writeActions.has(resource) && userPermissions.includes(`${module}.manage`)) return true;
  }

  return false;
}

export function hasAnyPermissionMatch(userPermissions: string[], requiredPermissions?: string[]): boolean {
  if (!requiredPermissions?.length) return true;
  return requiredPermissions.some((p) => hasPermissionMatch(userPermissions, p));
}
